<template>
  <div class="page-content global-typography">
    <sc-text :field="fields.PageTitle" tag="h1" />
    <sc-rich-text :field="fields.PageContent" />
  </div>
</template>

<script>
import { Text, RichText, isExperienceEditorActive } from '@sitecore-jss/sitecore-jss-vue';
export default {
  name: 'PageContent',
  data() {
    return {};
  },
  props: {
    fields: {
      type: Object,
      default: () => ({
        PageTitle: null,
        PageContent: '',
      }),
    },
  },
  components: {
    ScText: Text,
    ScRichText: RichText,
  },
  computed: {
    isSitecoreExperienceEditorOn() {
      // TODO may need to add other check like the preview mode
      return isExperienceEditorActive();
    },
  },
  methods: {
  },
};
</script>
<style lang="scss" scoped>
a:link {
  text-decoration: none;
}

::v-deep {
  h1 {
    margin: 0 0 0.75rem 0;
    @media #{map-get($display-breakpoints, 'xs-only')} {
      padding-top: 1.5rem;
    }
    @media #{map-get($display-breakpoints, 'sm-and-up')} {
      margin-bottom: 1.5rem;
      padding: 0;
    }
  }
  p {
    @media #{map-get($display-breakpoints, 'lg-and-up')} {
      margin-bottom: 0.8rem;
    }
  }
}
</style>
